import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DialogEditAiReviewComponent } from '@app/shared/components/dialog-edit-ai-review/dialog-edit-ai-review.component';
import { DialogEditMessageComponent } from '@app/shared/components/dialog-edit-message/dialog-edit-message.component';
import { PreferencesService } from '@app/shared/services/preferences/preferences.service';
import { RuleService } from '@app/shared/services/rule/rule.service';
import { MessageReview, MessageSendReview } from '@app/shared/services/thread/thread.service';
import { TitleService } from '@app/shared/services/title/title.service';

@Component({
  standalone: false,
  selector: 'sbnb-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  counts: any;
  scheduledMessages: any[];
  loadingScheduledMessages: boolean;

  scheduledReviews: any[];
  loadingScheduledReviews: boolean;

  reviewReplies: any[];
  loadingReviewReplies = false;
  expandedReviews: MessageReview['id'][] = [];

  constructor(
    private prefsService: PreferencesService,
    private titleService: TitleService,
    private ruleService: RuleService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.titleService.manuallySet('Guest Experience');

    this.ruleService.getOverviewCounts().subscribe((res) => {
      this.counts = res;
    });

    this.loadingScheduledMessages = true;
    this.ruleService.getScheduledMessages().subscribe((res) => {
      this.scheduledMessages = res;
      this.loadingScheduledMessages = false;
    });

    this.loadingScheduledReviews = true;
    this.ruleService.getScheduledReviews().subscribe((res) => {
      this.scheduledReviews = res;
      this.loadingScheduledReviews = false;
    });

    this.loadingReviewReplies = true;
    this.ruleService.getReviewReplies().subscribe((res) => {
      this.reviewReplies = res;
      this.loadingReviewReplies = false;
    });
  }

  openEditMessageDialog(messageId: string) {
    const dialogRef = this.dialog.open(DialogEditMessageComponent, {
      width: '720px',
      panelClass: 'dialog__no-padding',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        messageId,
      },
    });

    dialogRef.afterClosed().subscribe((result: { status: 'updated' | 'sent' | 'deleted'; updatedItem: any }) => {
      // Check if they just saved, sent now, or deleted and update the list accordingly
      if (!result?.status) {
        return;
      }

      if (result.status === 'updated') {
        const index = this.scheduledMessages.findIndex((x) => x.randomkey === result.updatedItem.randomkey);

        if (index > -1) {
          this.scheduledMessages[index] = result.updatedItem;
        }
      }

      if (result.status === 'sent' || result.status === 'deleted') {
        const index = this.scheduledMessages.findIndex((x) => x.randomkey === messageId);

        if (index > -1) {
          this.scheduledMessages.splice(index, 1);
        }
      }
    });
  }

  openEditReviewDialog(reviewId: string) {
    const dialogRef = this.dialog.open(DialogEditAiReviewComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        reviewId,
      },
    });

    dialogRef.afterClosed().subscribe((result: Partial<MessageSendReview> | { cancelled_at: Date }) => {
      // Check if they just saved, sent now, or deleted and update the list accordingly
      if ((result as { cancelled_at: Date })?.cancelled_at || (result as Partial<MessageSendReview>)?.submitted) {
        const index = this.scheduledReviews.findIndex((x) => x.review_id === reviewId);

        if (index > -1) {
          this.scheduledReviews.splice(index, 1);
        }
      }
    });
  }

  onPendingReviewReplySent(reviewId: MessageReview['id']) {
    const index = this.reviewReplies.findIndex((x) => x.id === reviewId);

    if (index > -1) {
      this.reviewReplies.splice(index, 1);
    }

    // if we have a next in the list after the reviewId, expand it automatically
    const nextIndex = this.reviewReplies.findIndex((x) => x.id === reviewId + 1);

    if (nextIndex > -1) {
      this.expandedReviews.push(reviewId + 1);
    }
  }

  toggleExpandedReview(reviewId: MessageReview['id']) {
    if (this.expandedReviews.includes(reviewId)) {
      this.expandedReviews = this.expandedReviews.filter((x) => x !== reviewId);
    } else {
      this.expandedReviews.push(reviewId);
    }
  }
}
